<div *ngIf="createUpdateEntity" class="update-entity" style="font-size: 0.8rem">
  <app-show-create-update-connection-object-contact-data [createUpdateEntity]="createUpdateEntity" />

  <div class="text-with-icon">
    <ng-container *ngIf="createUpdateEntity.createdDate">
      <b>Erstellungsdatum:</b>
      {{ createUpdateEntity.createdDate | date : 'shortDate' }}
      <ng-container *ngIf="createdByCustomer && createUpdateEntity.createdBy">
        (
        <b>Endkunde:</b>
        {{ createdByCustomer.firstName }} {{ createdByCustomer.lastName }} )
      </ng-container>
      <ng-container *ngIf="!createdByCustomer && createUpdateEntity.createdBy">
        <span
          style="font-size: 160%"
          class="material-symbols-outlined"
          tiptool="{{ createUpdateEntity.createdBy | tenantlessEmail }}"
          placement="right">
          info
        </span>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="createUpdateEntity.modifiedDate">
      <b>&nbsp;&nbsp;&nbsp;&nbsp; Letzte Änderung:</b>
      {{ createUpdateEntity.modifiedDate | date : 'shortDate' }}
      <ng-container *ngIf="createUpdateEntity.lastModifiedBy">
        <span
          style="font-size: 160%"
          class="material-symbols-outlined"
          tiptool="{{ createUpdateEntity.lastModifiedBy | tenantlessEmail }}"
          placement="right">
          info
        </span>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="createUpdateEntity.activities">
      <app-show-last-activity
        [activities]="createUpdateEntity.activities"
        [statusModule]="statusModule"></app-show-last-activity>
    </ng-container>
  </div>
</div>
